import { toast } from 'vue-sonner'
import { useDeepBoxDeepBoxesBoxesFavoritesStore } from '@/stores/deepbox/deepboxes/boxes/favorites.ts'
import type { BoxEntry } from '@deepcloud/api-deep-box'

export function useBoxFavorites() {
  const { t } = useI18n()
  const deepBoxDeepBoxesBoxesFavoritesStore =
    useDeepBoxDeepBoxesBoxesFavoritesStore()

  function isBoxFavorite(box: BoxEntry) {
    if (deepBoxDeepBoxesBoxesFavoritesStore.favorites.length > 0) {
      return deepBoxDeepBoxesBoxesFavoritesStore.favorites.find(
        (fav) => fav.boxNodeId === box.boxNodeId,
      )
    }
    return false
  }

  function getBoxFavoriteIcon(box: BoxEntry) {
    return isBoxFavorite(box) ? 'fas fa-star' : 'far fa-star'
  }

  function getBoxFavoriteText(box: BoxEntry) {
    return isBoxFavorite(box)
      ? t('labels.menu.actions.favorites.remove')
      : t('labels.menu.actions.favorites.add')
  }

  function getBoxName(box: BoxEntry) {
    if (!box) return

    return 'name' in box ? box.name : box.boxName
  }

  async function onBoxAddToFavorites(box: BoxEntry) {
    try {
      await deepBoxDeepBoxesBoxesFavoritesStore.addToFavorites(box)
      toast.success(
        t('toast.box.favorites.success_added', {
          boxName: getBoxName(box),
        }),
      )
    } catch {
      toast.error(t('error.error_occurred'))
    }
  }

  async function onBoxRemoveFromFavorites(box: BoxEntry) {
    try {
      await deepBoxDeepBoxesBoxesFavoritesStore.removeFromFavorites(box)
      toast.success(
        t('toast.box.favorites.success_removed', {
          boxName: getBoxName(box),
        }),
      )
    } catch {
      toast.error(t('error.error_occurred'))
    }
  }

  return {
    isBoxFavorite,
    getBoxFavoriteIcon,
    getBoxFavoriteText,
    onBoxAddToFavorites,
    onBoxRemoveFromFavorites,
  }
}
